import { gql } from '@apollo/client';

export * from './migrateLegacyRepos.mutation.generated';

export const MIGRATE_LEGACY_REPOS = gql`
  mutation migrateLegacyRepos($legacyRepoIds: [ID!]!, $integrationId: ID!) {
    migrateLegacyRepos(input: { legacyRepoIds: $legacyRepoIds, integrationId: $integrationId }) {
      success
      errors
      migratedLegacyRepos {
        id
      }
    }
  }
`;
